import { useEffect, useState } from "react"

export const useVendorConsent = (vendorId) => {
  const [vendorConsentStatus, setVendorConsentStatus] = useState(!window.DIDOMI?.ENABLED)

  useEffect(() => {
    let cancelled = false

    const apply = (didomiInstance) => {
      if (cancelled) return

      if (!didomiInstance.isConsentRequired()) {
        setVendorConsentStatus(true)
        return
      }

      const vendor = didomiInstance.getCurrentUserStatus().vendors[vendorId]
      const vendorEnabled = vendor?.enabled === true
      setVendorConsentStatus(vendorEnabled)

      didomiInstance.addVendorStatusListener(vendorId, (status) => {
        if (!cancelled) setVendorConsentStatus(status === true)
      })
    }

    if (window.Didomi) {
      apply(window.Didomi)
    } else {
      window.didomiOnReady = window.didomiOnReady || []
      window.didomiOnReady.push(apply)
    }

    // TODO: how to unsubscribe the listener with new api? does it matter?
    return () => {
      cancelled = true
    }
  }, [vendorId])

  return vendorConsentStatus
}
